export default "<!--\n    Made with <3 by Yann Thoraval\n-->\n<p>lightbox works!</p>\n"